﻿import "../app";
import "@fiqas/utils"
import { IResourceOf, IResourceResolver } from "../interfaces/iFqs"
import { Person } from "./person"

export type RecordHistoryType = "document" | "description" | "property" | "feedbackStatus" | "watch" | "title";

export interface RecordHistory extends IResourceOf<RecordHistory> {
    modifiedBy: string;
    modifiedById: IResourceResolver<Person>;
    modifiedOn: ISODateTimeString;
    oldContent: string
    newContent: string;
    itemName: string;
    itemDesc: string;
    itemType: RecordHistoryType;
}
